"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _beforeMen = require("@/api/beforeMen/beforeMen");
var _recommendCourse = require("@/api/recommendCourse");
var _validate = require("@/libs/validate1.js");
var _public = require("@/api/public/public");
var _nav = require("@/api/nav/nav");
var _vuex = require("vuex");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _auth = require("@/libs/auth");
var _axios = _interopRequireDefault(require("axios"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "login",
  computed: _objectSpread({}, (0, _vuex.mapState)({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  })),
  data: function data() {
    return {
      isShow: false,
      xzList: [{
        name: "资源库",
        url: "https://www.icve.com.cn/studycenter/welcome/welcome.html"
      }, {
        name: "SPOC",
        url: "https://user.icve.com.cn/cms/"
      }, {
        name: "MOOC",
        url: "https://icve-mooc.icve.com.cn/cms/"
      }],
      navActive: "/",
      provinceId: "",
      isHome: 0,
      isNewsDetail: 0,
      businessId: "",
      isBack: false,
      loading: false,
      actNum: null,
      isEnter: true,
      checked: true,
      loginDialog: false,
      boxLoginShow: true,
      phoneTipShow: false,
      opacity: "",
      count: "",
      timer: null,
      showVerification: true,
      codeImg: "",
      navList: [{
        name: "首页",
        img: require("@/assets/img/icon-topmenu1.png"),
        url: "/"
      },
      // {name:'新闻中心',img:require('@/assets/img/icon-topmenu1.png'),url:'/reNews'},
      {
        name: "专业资源库",
        img: require("@/assets/img/icon-topmenu3.png"),
        url: "/professionalTeaching"
      }, {
        name: "在线精品课",
        img: require("@/assets/img/icon-topmenu4.png"),
        url: "/boutiqueCourse"
      }, {
        name: "视频公开课",
        img: require("@/assets/img/icon-topmenu5.png"),
        url: "/virtualCourse"
      }
      // {name:'赛事专栏',img:require('@/assets/img/icon-topmenu6.png'),url:'/competition'}
      ],
      userLogin: {
        userHd: require("@/assets/img/user.png"),
        username: "登录"
      },
      logo: "",
      footerTxt: "",
      userMsg: {
        username: "",
        password: ""
      },
      // 登录框规则
      userRules: {
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          min: 2,
          max: 18,
          message: "长度在 2 到 18 个字符",
          trigger: "blur"
        }, {
          required: true,
          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          message: "账号不支持特殊字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }]
      },
      loginLogo: "",
      hdColor: 0,
      icveLoginName: ""
    };
  },
  methods: {
    // 登录选择跳转
    tiaozhuan: function tiaozhuan(url) {
      window.open(url);
      this.isShow = false;
    },
    goToIcve: function goToIcve() {
      var role = JSON.parse(sessionStorage.getItem("ROLE"));
      var userType = sessionStorage.getItem("USERTYPE");
      if (role.length > 0) {
        var PATH = sessionStorage.getItem("PATH");
        sessionStorage.setItem("curNav", sessionStorage.getItem("curNav1"));
        sessionStorage.setItem("$index", "0");
        sessionStorage.setItem("ISSHOW", true);
        sessionStorage.removeItem("sidebar");
        location.href = window.location.origin + "/icve-admin" + PATH;
      } else if (userType == 2) {
        location.href = window.location.origin + "/icve-teacher/";
      } else {
        location.href = window.location.origin + "/icve-study/";
      }
    },
    //退出登录并清除cookie
    quitIcveLogin: function quitIcveLogin() {
      var _this = this;
      // removeToken1();
      sessionStorage.removeItem("curNav");
      sessionStorage.removeItem("$index");
      sessionStorage.removeItem("sidebar");
      sessionStorage.removeItem("zyList");
      sessionStorage.removeItem("classList");
      sessionStorage.removeItem("yxList");
      sessionStorage.removeItem("ROLE");
      sessionStorage.removeItem("USERTYPE");
      sessionStorage.removeItem("ISSHOW");
      sessionStorage.removeItem("displayName");
      (0, _recommendCourse.logout)(_jsCookie.default.get("token")).then(function () {
        _this.icveLoginName = "";
        _this.$message.success("退出成功！");
        (0, _auth.removeToken)();
      });
      // document.cookie =
      //   "token=;expires=Thu,01 Jan 1970 00:00:00 UTC;domain=.icve.com.cn;path=/;";
      /*  Cookies.set("auth", "", {
            domain: ".icve.com.cn"
          });
          Cookies.remove("displayName");
          this.icveLoginName = "";*/
    },
    openUserService: function openUserService(url) {
      window.open(url);
    },
    getVerificationCode: function () {
      var _getVerificationCode = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var res, TIME_COUNT;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log(this.userMsg.phone, "this.userMsg");
              if (!(this.userMsg.phone == "" || this.userMsg.phone.length < 11)) {
                _context.next = 1;
                break;
              }
              this.phoneTipShow = true;
              _context.next = 3;
              break;
            case 1:
              this.phoneTipShow = false;
              _context.next = 2;
              return (0, _public.sendLoginMessage)({
                mobile: this.userMsg.phone
              });
            case 2:
              res = _context.sent;
              if (res.code == 2000) {
                TIME_COUNT = 59;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.showVerification = false;
                  this.timer = setInterval(function () {
                    if (_this2.count > 1 && _this2.count <= TIME_COUNT) {
                      _this2.count--;
                    } else {
                      _this2.showVerification = true;
                      clearInterval(_this2.timer);
                      _this2.timer = null;
                    }
                  }, 1000);
                }
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVerificationCode() {
        return _getVerificationCode.apply(this, arguments);
      }
      return getVerificationCode;
    }(),
    goSign: function goSign() {
      this.boxLoginShow = !this.boxLoginShow;
      this.userMsg.phone = "", this.userMsg.verificationCode = "", clearInterval(this.timer);
      this.timer = null;
      this.showVerification = true;
      this.count = "";
    },
    goPath: function goPath(url, name) {
      if (url == "") {
        return this.$notify.info({
          title: "提示",
          message: "该功能正在建设中"
        });
      }
      this.$router.push(url);
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["category_click", "CLK", {
          //以下为事件属性
          category_name: name,
          // 导航栏名称
          category_id: "" //导航栏id
        }]
      });
    },
    // 获取课程来源
    getCourseSource: function getCourseSource() {
      var _this3 = this;
      (0, _beforeMen.courseSource)({
        provinceId: this.provinceId
      }).then(function (res) {
        for (var i in res.data) {
          _this3.$set(res.data[i], "value", res.data[i].id);
        }
        _this3.$store.commit("settings/getwCourseSource", res.data);
      });
    },
    // 获取产业分类
    getIndustry: function getIndustry() {
      var _this4 = this;
      (0, _beforeMen.industryListAll)({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this4.$store.commit("settings/getwIndustryType", res.rows);
      });
    },
    // 获取行业门类
    getIndustryCategory: function getIndustryCategory() {
      var _this5 = this;
      (0, _beforeMen.industryCategory)({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this5.$store.commit("settings/getwIndustryCategory", res.rows);
      });
    },
    // // 获取项目级别
    // getProjectLevel() {
    //   projectLevel({
    //     name: "",
    //     pageNum: 1,
    //     pageSize: 1000,
    //   }).then((res) => {
    //     for (let i in res.rows) {
    //       this.$set(res.rows[i], "value", res.rows[i].id);
    //     }
    //     this.$store.commit("settings/getwProjectLevel", res.rows);
    //   });
    // },
    // 获取资源库类型
    getResourceType: function getResourceType() {
      var _this6 = this;
      (0, _beforeMen.resourceType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this6.$store.commit("settings/getwResourceType", res.data);
      });
    },
    // 获取资源库分类
    getProfessionalResourceLibraryType: function getProfessionalResourceLibraryType() {
      var _this7 = this;
      (0, _beforeMen.professionalResourceLibraryType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this7.$store.commit("settings/getwProfessionalResourceLibraryType", res.data);
      });
    },
    // 获取层次管理
    getCourseLevel: function getCourseLevel() {
      var _this8 = this;
      (0, _beforeMen.courseLevel)({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this8.$store.commit("settings/getwCourseLevel", res.rows);
      });
    },
    getYearListAll: function getYearListAll() {
      var _this9 = this;
      (0, _beforeMen.yearListAll)({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this9.$store.commit("settings/getwYearListAll", res.rows);
      });
    },
    // 获取应用类型
    getApplicationType: function getApplicationType() {
      var _this0 = this;
      (0, _beforeMen.applicationType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this0.$store.commit("settings/getwApplicationType", res.data);
      });
    },
    // 获取媒体类型
    getMediaType: function getMediaType() {
      var _this1 = this;
      (0, _beforeMen.mediaType)({
        provinceId: this.provinceId
      }).then(function (res) {
        _this1.$store.commit("settings/getwMediaType", res.data);
      });
    },
    // 获取专业大类
    getMajor: function getMajor() {
      var _this10 = this;
      (0, _beforeMen.getMatchMajorListAll)({
        businessId: "",
        parentId: "0"
      }).then(function (res) {
        if (res.code === 2000) {
          _this10.$store.commit("settings/getwMajorListAll", res.data);
          console.log("专业大类", _this10.$store.getters.wMajorListAll);
        }
      });
    },
    // toRegister() {
    //   this.loginDialog = true;
    //   this.boxLoginShow = false
    // },
    // 获取导航
    getNav: function getNav() {
      (0, _nav.navCode)({
        param: this.prCode
      }).then(function (res) {
        // this.navList = res.data;
      });
    },
    // 显示登录弹出框
    isLogin: function isLogin() {
      document.cookie = "token=;expires=Thu,01 Jan 1970 00:00:00 UTC;domain=.icve.com.cn;path=/;";
      sessionStorage.removeItem("curNav");
      sessionStorage.removeItem("$index");
      sessionStorage.removeItem("sidebar");
      sessionStorage.removeItem("zyList");
      sessionStorage.removeItem("classList");
      sessionStorage.removeItem("yxList");
      sessionStorage.removeItem("ROLE");
      sessionStorage.removeItem("USERTYPE");
      sessionStorage.removeItem("ISSHOW");
      sessionStorage.removeItem("displayName");
      (0, _auth.removeToken)();
      window.location.href = "https://sso.icve.com.cn/sso/auth?mode=simple&redirect=https://vocational.beijing.smartedu.cn/icve-admin/pedding&source=7"; //北京平台正式环境
    },
    // 获取验证码
    // getImgCode() {
    //   getImgCode().then(res => {
    //     this.codeImg = "data:image/jpg;base64," + res.data.codeImage;
    //     this.userMsg.keyId = res.data.keyId;
    //   });
    // },
    // 设置flag
    setFlag: function setFlag() {
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        var data = res.data;
        sessionStorage.setItem("book", JSON.stringify(data.expertAuthentication));
      });
    },
    // 登录国家平台
    login: function login(v) {
      var _this11 = this;
      this.$refs[v].validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!valid) {
                  _context2.next = 2;
                  break;
                }
                if (_this11.checked) {
                  _context2.next = 1;
                  break;
                }
                _this11.$message.error("请先同意协议!");
                return _context2.abrupt("return");
              case 1:
                _this11.loading = true;
                (0, _public.icveLogin)({
                  loginName: _this11.userMsg.username,
                  password: _this11.userMsg.password
                }).then(function (res) {
                  console.log("res", res);
                  if (res.code === 2000) {
                    if (res.data.auth != "" && res.data.auth != undefined && res.data.auth != null) {
                      if (res.data.auth.indexOf(";") > 0) {
                        _jsCookie.default.set("auth", res.data.auth.split(";")[0], {
                          domain: ".icve.com.cn"
                        });
                      } else {
                        _jsCookie.default.set("auth", res.data.auth, {
                          domain: ".icve.com.cn"
                        });
                      }
                      if (_jsCookie.default.get("auth")) {
                        _jsCookie.default.set("displayName", res.data.displayName);
                        _jsCookie.default.set("icveUserType", res.data.userType);
                        _this11.icveLoginName = _jsCookie.default.get("displayName");
                      }
                      _this11.loginDialog = false;
                      _this11.isShow = true;
                      //   if (res.data.userType == "1") {
                      //     window.open(
                      //       "https://www.icve.com.cn/studycenter/welcome/welcome.html"
                      //     );
                      //   } else if (res.data.userType == "2") {
                      //     window.open(
                      //       "https://www.icve.com.cn/studycenter/welcome/welcome.html"
                      //     );
                      //   } else if (res.data.userType == "3") {
                      //     window.open(
                      //       "https://www.icve.com.cn/hep/welcome/welcome.html"
                      //     );
                      //   } else if (res.data.userType == "14") {
                      //     window.open(
                      //       "https://www.icve.com.cn/project/welcome/index.html?ProjectType=1"
                      //     );
                      //   } else {
                      //     window.open(
                      //       "https://www.icve.com.cn/studycenter/mycourse/studingcourse.html"
                      //     );
                      //   }
                    }
                  }
                  _this11.loading = false;
                }).catch(function (err) {
                  _this11.loading = false;
                });
                _context2.next = 3;
                break;
              case 2:
                _this11.loading = false;
              case 3:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 注册国家平台
    toRegister: function toRegister(v) {
      window.location.href = "https://sso.icve.com.cn/sso/register?mode=simple&redirect=https://vocational.beijing.smartedu.cn/icve-admin/pedding&source=7"; //北京平台线上

      // this.$refs[v].validate(async valid => {
      //   if (valid) {
      //     if (!this.checked) {
      //       this.$message.error('请先同意协议!')
      //       return
      //     }
      //     this.loading = true;
      //     const res = await registerBySms({
      //       mobile: this.userMsg.phone,
      //       code: this.userMsg.verificationCode
      //     })
      //     if (res.data.code == '000000' && res.data.data != false) {
      //       this.$message.success(res.data.msg);
      //       this.goSign()
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //     this.loading = false;
      //   } else {
      //     this.loading = false;
      //     return
      //   }
      // });
    },
    // 前往后台
    backToHt: function backToHt() {
      var role = JSON.parse(sessionStorage.getItem("ROLE"));
      var userType = sessionStorage.getItem("USERTYPE");
      if (role.length > 0) {
        sessionStorage.setItem("curNav", sessionStorage.getItem("curNav1"));
        sessionStorage.setItem("$index", "0");
        sessionStorage.setItem("ISSHOW", true);
        sessionStorage.removeItem("sidebar");
        location.href = window.location.origin + sessionStorage.getItem("PATH");
      } else if (userType == 2) {
        location.href = window.location.origin + "/icve-teacher/";
      } else {
        location.href = window.location.origin + "/icve-study/";
      }
    },
    // 获取网站标题logo,文字描述
    getWebLogo: function getWebLogo() {
      var _this12 = this;
      (0, _public.webConfig)({
        param: this.prCode
      }).then(function (res) {
        if (res.code === 2000) {
          var data = res.data;
          _this12.logo = data.webLogo;
          _this12.footerTxt = data.footer;
          _this12.loginLogo = data.loginLogo;
          _this12.$store.commit("settings/getwTitle", data);
          _this12.$store.commit("settings/getProvinceId", data.provinceId);
        }
      });
    }
  },
  watch: {
    "$route.path": function $routePath(newVal, oldVal) {
      // console.log(newVal, "newVal", oldVal, "oldVal");
      this.navActive = newVal;
      if (newVal == "/deYu") {
        this.hdColor = 1;
      } else if (newVal == "/tiYu") {
        this.hdColor = 2;
      } else if (newVal == "/meiYu") {
        this.hdColor = 3;
      } else {
        this.hdColor = 0;
      }
      localStorage.setItem("hdColor", this.hdColor);
      if (newVal === "/") {
        this.isHome = 1;
      } else {
        this.isHome = 0;
      }
      if (newVal === "/newsDetail" || newVal === "/competitionDetail") {
        this.isNewsDetail = 1;
      } else {
        this.isNewsDetail = 0;
      }
      if (oldVal === "/reNews") {
        this.actNum = 1;
      } else if (oldVal === "/competition") {
        this.actNum = 5;
      }
      // 将页面滚动到顶部
      this.$root.$el.scrollTop = 0;
    }
  },
  created: function created() {
    var v = this.$route.path;
    // if (Cookies.get("auth")) {
    //   this.icveLoginName = Cookies.get("displayName");
    // }
    if (sessionStorage.getItem("displayName")) {
      this.icveLoginName = sessionStorage.getItem("displayName");
    }
    if (localStorage.getItem("hdColor")) {
      this.hdColor = localStorage.getItem("hdColor");
    } else {
      this.hdColor = 0;
    }
    // this.getWebLogo();
    if (v === "/") {
      this.hdColor = 0;
      this.isHome = 1;
    } else {
      this.isHome = 0;
    }
    if (v === "/newsDetail" || v === "/competitionDetail") {
      this.isNewsDetail = 1;
    } else {
      this.isNewsDetail = 0;
    }
    if (v === "/reNews") {
      this.actNum = 1;
    } else if (v === "/competition") {
      this.actNum = 5;
    }
    // 获取导航
    // this.getNav();
    // 本地存储导航样式下标
    sessionStorage.setItem("actNum", this.actNum);
    // 判断状态
    var e = sessionStorage.getItem("info");
    if (e) {
      this.isBack = true;
      // this.userLogin.userHd = JSON.parse(e).avatarUrl;
    } else {
      this.isBack = false;
    }
    this.getIndustry(); // 获取产业分类
    this.getIndustryCategory(); // 获取行业门类
    // this.getProjectLevel(); // 获取项目级别
    // this.getResourceType(); // 获取资源库类型
    // this.getProfessionalResourceLibraryType(); // 获取资源库分类
    this.getCourseLevel(); // 获取层次管理
    this.getYearListAll();
    // this.getApplicationType(); // 获取应用类型
    // this.getMediaType(); // 获取媒体类型
    // this.getCourseSource(); // 获取课程来源
    // this.getMajor()
  }
};